export default "__VITE_ASSET__gLqy0Old__"